// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.admin-container[data-v-6780aed4]{\n    height: calc(100vh - 42px);margin-top: 42px;width: inherit;\n}\n.body-container[data-v-6780aed4]{\n    height: inherit;\n}\n.body-container .left-sidebar-container[data-v-6780aed4]{\n    width: 240px;\n}\n\n\n", ""]);
// Exports
module.exports = exports;
